import Hero from '~/components/sanity/SanityHeroModule.vue';
import Divider from '~/components/sanity/SanityDivider.vue';
import Grid from '~/components/sanity/SanityGrid.vue';
import Testimonials from '~/components/sanity/SanityTestimonials.vue';
import Widget from '~/components/sanity/SanityWidget.vue';
export default {
  name: 'SanityModule',
  components: {
    Hero,
    Divider,
    Grid,
    Testimonials,
    Widget
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    dataType() {
      if (this.data._type === 'oldGrid') return 'grid';else return this.data._type;
    }
  }
};